/** URL for a file shipped in public/.
 *
 * Absolute paths such as "/logos/emblem.png" break as soon as the app is served
 * under a prefix: at /app/ the browser asks for https://host/logos/... which is
 * outside the SPA and hits Django instead. BASE_URL is whatever vite was built
 * with ("/" or "/app/"), and always ends in a slash.
 */
export function assetUrl(relativePath: string): string {
  return `${import.meta.env.BASE_URL}${relativePath.replace(/^\/+/, '')}`;
}
